(function () {
  'use strict';

  if (window.innerWidth > 768) return;

  var selectedVariantId = null;
  var ui = null;

  function buildUI() {
    var overlay = document.createElement('div');
    overlay.id = 'kg-mobile-size-overlay';
    document.body.appendChild(overlay);

    var sheet = document.createElement('div');
    sheet.id = 'kg-mobile-size-sheet';
    sheet.innerHTML = [
      '<div class="kg-sheet-handle"></div>',
      '<div class="kg-sheet-product-row">',
        '<div class="kg-sheet-thumb"><img id="kg-sheet-img" src="" alt="" /></div>',
        '<div>',
          '<p class="kg-sheet-product-name" id="kg-sheet-name"></p>',
          '<p class="kg-sheet-product-price" id="kg-sheet-price"></p>',
        '</div>',
      '</div>',
      '<p class="kg-sheet-size-label">Select size</p>',
      '<div class="kg-sheet-size-grid" id="kg-sheet-size-grid"></div>',
      '<button type="button" class="kg-sheet-atc-btn" id="kg-sheet-atc-btn" disabled>',
        '<span id="kg-sheet-btn-text">Select a size</span>',
      '</button>'
    ].join('');
    document.body.appendChild(sheet);

    var toast = document.createElement('div');
    toast.id = 'kg-mobile-toast';
    toast.innerHTML = '<span id="kg-toast-text">Added to cart</span>';
    document.body.appendChild(toast);

    return { overlay: overlay, sheet: sheet, toast: toast };
  }

  function openSheet(productData) {
    selectedVariantId = null;

    document.getElementById('kg-sheet-name').textContent = productData.title;
    document.getElementById('kg-sheet-price').textContent = productData.price;

    var imgEl = document.getElementById('kg-sheet-img');
    imgEl.src = productData.image || '';
    imgEl.alt = productData.title;

    var grid = document.getElementById('kg-sheet-size-grid');
    grid.innerHTML = '';

    productData.variants.forEach(function (variant) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'kg-sheet-size-btn' + (!variant.available ? ' kg-unavailable' : '');
      btn.textContent = variant.label;
      if (!variant.available) btn.disabled = true;

      btn.addEventListener('click', function () {
        grid.querySelectorAll('.kg-sheet-size-btn').forEach(function (b) {
          b.classList.remove('kg-selected');
        });
        btn.classList.add('kg-selected');
        selectedVariantId = variant.id;

        var atcBtn = document.getElementById('kg-sheet-atc-btn');
        atcBtn.disabled = false;
        document.getElementById('kg-sheet-btn-text').textContent = 'Add to cart — ' + variant.label;
      });

      grid.appendChild(btn);
    });

    var atcBtn = document.getElementById('kg-sheet-atc-btn');
    atcBtn.disabled = true;
    document.getElementById('kg-sheet-btn-text').textContent = 'Select a size';
    atcBtn.onclick = function () {
      if (!selectedVariantId) return;
      var selBtn = grid.querySelector('.kg-sheet-size-btn.kg-selected');
      var label = selBtn ? selBtn.textContent : '';
      addToCart(selectedVariantId, productData.title, label);
    };

    ui.overlay.classList.add('kg-active');
    ui.sheet.classList.add('kg-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSheet() {
    ui.overlay.classList.remove('kg-active');
    ui.sheet.classList.remove('kg-open');
    document.body.style.overflow = '';
    selectedVariantId = null;
  }

  var toastTimer;
  function showToast(msg) {
    document.getElementById('kg-toast-text').textContent = msg;
    ui.toast.classList.add('kg-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { ui.toast.classList.remove('kg-show'); }, 3000);
  }

  function addToCart(variantId, title, sizeLabel) {
    var atcBtn = document.getElementById('kg-sheet-atc-btn');
    atcBtn.disabled = true;
    document.getElementById('kg-sheet-btn-text').textContent = 'Adding...';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) return res.json().then(function (e) { throw new Error(e.description || 'Error'); });
      return res.json();
    })
    .then(function () {
      closeSheet();
      showToast((title || 'Item') + (sizeLabel ? ' (' + sizeLabel + ')' : '') + ' added to cart');
      refreshCartCount();
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    })
    .catch(function (err) {
      atcBtn.disabled = false;
      document.getElementById('kg-sheet-btn-text').textContent = err.message || 'Error, try again';
    });
  }

  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        [
          '[data-cart-count]','[data-cart-item-count]','.cart-count',
          '.header__cart-count','.js-cart-count','cart-count',
          '.cart-count-bubble span:not(.visually-hidden)'
        ].forEach(function (sel) {
          document.querySelectorAll(sel).forEach(function (el) { el.textContent = count; });
        });
      }).catch(function () {});
  }

  function formatPrice(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL';
  }

  function getHandle(card) {
    var h = card.getAttribute('data-handle') || card.getAttribute('data-product-handle');
    if (h) return h;
    var links = card.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var m = (links[i].getAttribute('href') || '').match(/\/products\/([^?#/]+)/);
      if (m && m[1]) return m[1];
    }
    return null;
  }

  function buildVariantList(product) {
    var sizeIdx = 0;
    if (product.options) {
      product.options.forEach(function (opt, i) {
        var name = (opt.name || opt || '').toLowerCase();
        if (name === 'size' || name === 'beden' || name === 'boyut') sizeIdx = i;
      });
    }
    var seen = {};
    var list = [];
    product.variants.forEach(function (v) {
      var keys = ['option1', 'option2', 'option3'];
      var label = v[keys[sizeIdx]] || v.option1;
      if (!label) return;
      if (!seen[label]) {
        seen[label] = true;
        list.push({ id: v.id, label: label, available: v.available });
      } else if (v.available) {
        var ex = null;
        for (var j = 0; j < list.length; j++) { if (list[j].label === label) { ex = list[j]; break; } }
        if (ex && !ex.available) { ex.id = v.id; ex.available = true; }
      }
    });
    return list;
  }

  var cache = {};
  function fetchProduct(handle, cb) {
    if (cache[handle]) { cb(cache[handle]); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (d) { cache[handle] = d; cb(d); })
      .catch(function (e) { console.error('[KG Quick Add]', e); });
  }

  function injectButton(card) {
    if (card.querySelector('.kg-mobile-quick-add-btn')) return;

    var figure = card.querySelector('.product-card__figure, .product-card__media, figure');
    if (!figure) return;

    var handle = getHandle(card);
    if (!handle) return;

    if (window.getComputedStyle(figure).position === 'static') {
      figure.style.position = 'relative';
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kg-mobile-quick-add-btn';
    btn.setAttribute('aria-label', 'Quick add to cart');
    btn.innerHTML = '<svg viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5" fill="none" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      var imgEl = figure.querySelector('img');
      var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src || imgEl.dataset.src || '') : '';
      imgSrc = imgSrc.replace(/(_\d+x[\d]*)(\.(jpg|png|webp|gif))/i, '_300x$2').split('?')[0];

      fetchProduct(handle, function (product) {
        var variants = buildVariantList(product);
        if (!variants.length) return;
        openSheet({
          title: product.title,
          price: formatPrice(product.price_min),
          image: imgSrc || product.featured_image || '',
          variants: variants
        });
      });
    });

    figure.appendChild(btn);
  }

  function injectAll() {
    document.querySelectorAll('product-card.kg-product-card').forEach(injectButton);
  }

  function init() {
    ui = buildUI();

    ui.overlay.addEventListener('click', closeSheet);

    var ty = 0;
    ui.sheet.addEventListener('touchstart', function (e) { ty = e.touches[0].clientY; }, { passive: true });
    ui.sheet.addEventListener('touchend', function (e) {
      if (e.changedTouches[0].clientY - ty > 70) closeSheet();
    }, { passive: true });

    injectAll();

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('product-card.kg-product-card')) injectButton(node);
          else if (node.querySelectorAll) node.querySelectorAll('product-card.kg-product-card').forEach(injectButton);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () { setTimeout(injectAll, 400); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
